// Import helpers
import { isLiveProgram } from 'helpers/time';
import { findCurrentLiveProgram } from 'store/helpers/epg';

export const setNextChannel = (channel, currentLiveIndex) => {
	if (channel.epgProgrammes.length - 1 !== currentLiveIndex) {
		const currentProgram = channel.epgProgrammes[currentLiveIndex];

		if (!currentProgram || isLiveProgram(currentProgram)) {
			return null;
		} else {
			const isProgramIndex = findCurrentLiveProgram(channel.epgProgrammes);

			return isProgramIndex && isProgramIndex !== currentLiveIndex ? isProgramIndex : null;
		}
	} else {
		return null;
	}
};
